import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonComponent } from '@ppl/ui';
import { NzColDirective, NzRowDirective } from "ng-zorro-antd/grid";
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent } from "ng-zorro-antd/form";
import { NzOptionComponent, NzSelectComponent } from "ng-zorro-antd/select";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { CommonModule, NgIf } from "@angular/common";
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { TimesheetService } from '../../../../services/timesheet.service';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { LookupService } from '../../../../services/lookup.service';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { UserService } from '../../../../services/user.service';
import { DatepickerComponent, MultiselectComponent } from '@ppl/ui';

const fields = [
  { field: 'Timeframe', show: true, default: '30 days' },
  { field: 'status', show: true },
  { field: 'status', show: true },
  { field: 'consumer', show: true },
  { field: 'consumerPplId', show: true },
  { field: 'provider', show: true },
  { field: 'providerPplId', show: true },
  { field: 'chequeNumber', show: true },
  { field: 'payPeriod', show: true, hideFuturePeriods: true },
  { field: 'processStatusLkp', show: true },
  { field: 'serviceCode', show: true },
  { field: 'serviceDate', show: true }
];

@Component({
  selector: 'ppl-timesheet-filter',
  standalone: true,
  imports: [
    ButtonComponent,
    NzColDirective,
    NzFormControlComponent,
    NzFormDirective,
    NzFormItemComponent,
    NzOptionComponent,
    NzRowDirective,
    NzSelectComponent,
    ReactiveFormsModule,
    NgIf,
    AuthorizeDirective,
    NzAutocompleteModule,
    NzDatePickerModule,
    DatepickerComponent,
    CommonModule,
    MultiselectComponent
  ],
  templateUrl: './timesheet-filter.component.html',
  styleUrls: ['./timesheet-filter.component.css']
})
export class TimesheetFilterComponent implements OnInit {
  @Input() filterFields: any[] = fields;
  @Input() includeBusinessStatus: any[] = [];
  @Input() processCodes: any[] = [];
  @Input() includeProcessingStatus: any[] = [];
  @Input() chequeNumbers: any[] = [];
  @Input() consumerList: any[] = [];
  @Input() export: boolean = false;
  @Input() pageId: string = '';
  @Output() searchEvent = new EventEmitter<any>();
  @Output() exportEvent = new EventEmitter<any>();
  statusList: LookupValueItem[] = [];
  processStatusList: LookupValueItem[] = [];
  filteredProcessStatusList: LookupValueItem[] = [];
  timesheetServiceCodes: LookupValueItem[] = [];

  payPeriodMultipleSelection = '';

  timesheetSearchForm!: FormGroup;
  consumers = [
    { id: 'PRC-NY-10000802', name: 'Nikhil Malhotra' },
    { id: 'PRC-NY-10000801', name: 'Henderson Branch' },
    { id: 'PRC-NY-10000797', name: 'Renata Laugherane' },
    { id: 'PRC-NY-10000796', name: 'Torry Hunton' },
    { id: 'PRC-NY-10000804', name: 'Gwenni Malhotra' },
  ];

  providers = [
    { id: 'PRC-NY-10000802', name: 'Nikhil Malhotra' },
    { id: 'PRC-NY-10000801', name: 'Henderson Branch' },
    { id: 'PRC-NY-10000797', name: 'Renata Laugherane' },
    { id: 'PRC-NY-10000796', name: 'Torry Hunton' },
    { id: 'PRC-NY-10000804', name: 'Gwenni Malhotra' },
  ];

  filteredConsumers: any[] = [];
  filteredProviders: any[] = [];
  status = [
    { id: '1', name: 'Approved' },
    { id: '2', name: 'Rejected' },
    { id: '3', name: 'In Review' },
  ];

  loopback = [
    { label: '30 days', val: '30 days' },
    { label: '60 days', val: '60 days' },
    { label: '90 days', val: '90 days' },
    { label: '120 days', val: '120 days' },
    { label: '150 days', val: '150 days' },
    { label: '180 days', val: '180 days' },
    { label: '1 year', val: '365 days' },
    { label: '2 years', val: '730 days' },
    { label: '3 years', val: '1095 days' },
  ];
  showErrors = false;
  isSearched = false;


  tabId: string = '';
  programName!: string;
  payPeriod: any[] = [];
  servicePeriods: any[] = [];

  constructor(private fb: FormBuilder, private timesheetService: TimesheetService,
    private lookupService: LookupService, private dateTimeFormatter: DateTimeFormatterService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    const formFields = this.filterFields.reduce((acc, f) => {
      if (f.show) {
        // `disabled: true` pins a filter to its default and greys it out — used by pages that are
        // scoped to a fixed status (e.g. Good To Pay). Disabled controls are excluded from
        // form.value, so the emit paths below read getRawValue().
        acc = { ...acc, [f.field]: [{ value: f.default ?? null, disabled: !!f.disabled }] };
      }
      return acc;
    }, {});
    this.timesheetSearchForm = this.fb.group(formFields);

    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    const businessStatusList = this.lookupService.getLookupValue('Business Status')
    this.statusList = this.includeBusinessStatus.length ? businessStatusList.filter((status: any) => {
      return this.includeBusinessStatus.includes(status.lkpValueCode);
    }) : businessStatusList;

    const processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    this.processStatusList = this.includeProcessingStatus.length ? processingStatusList.filter((status: any) => {
      return this.includeProcessingStatus.includes(status.lkpValueCode);
    }) : processingStatusList;
    // Statuses the Pended Timesheets list returns.
    this.filteredProcessStatusList = processingStatusList.filter(status => ['D', 'PE', 'RP', 'AC', 'SE'].includes(status.lkpValueCode));

    const timesheetServiceCodes = this.lookupService.getLookupValue('timesheet_filter_serviceCode');
    // transform timesheetservicecodes, include one more property 'label' which is combination of lkpValueCode and lkpValueName
    timesheetServiceCodes.forEach((code: any) => {
      code.label = `${code.lkpValueCode} - ${code.lkpValueName}`;
    });
    this.timesheetServiceCodes = timesheetServiceCodes;

    const payPeriodConfiguration = this.filterFields.find(entry => entry.field === 'payPeriod');
    if (payPeriodConfiguration) {
      this.getPayPeriod(payPeriodConfiguration.hideFuturePeriods);
      this.getServicePeriod(payPeriodConfiguration.hideFuturePeriods);
    }

    if (payPeriodConfiguration && payPeriodConfiguration.multiple) {
      this.payPeriodMultipleSelection = 'multiple';
    }
  }

  getPayPeriod(hideFuturePeriods: boolean) {
    this.timesheetService
      .getPayPeriod(this.programName)
      .subscribe((data: any) => {
        const payPeriodRecords = data.responsedata;
        if (hideFuturePeriods) {
          const today = new Date();
          const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());

          this.payPeriod = payPeriodRecords.filter((record: any) => {
            const startDate = new Date(record.payrollStartDate);
            const startMidnight = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());

            return startMidnight <= todayMidnight;
          });
        } else {
          this.payPeriod = payPeriodRecords;
        }
      });
  }

  getServicePeriod(hideFuturePeriods: boolean) {
    this.timesheetService
      .getServicePeriod(this.programName)
      .subscribe((data: any) => {
        const servicePeriodRecords = data.responsedata ?? [];
        if (hideFuturePeriods) {
          const today = new Date();
          const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());

          this.servicePeriods = servicePeriodRecords.filter((record: any) => {
            const startDate = new Date(record.workWeekStartDate);
            const startMidnight = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());

            return startMidnight <= todayMidnight;
          });
        } else {
          this.servicePeriods = servicePeriodRecords;
        }
      });
  }

  onInput(e: Event, fieldName: string): void {
    const value = (e.target as HTMLInputElement).value;

    if (fieldName === 'consumer') {
      this.filteredConsumers = value ? this.consumers.filter(c => c.name.toLowerCase().includes(value.toLowerCase())) : [];
    } else if (fieldName === 'provider') {
      this.filteredProviders = value ? this.providers.filter(c => c.name.toLowerCase().includes(value.toLowerCase())) : [];
    }

  }

  search() {
    this.showErrors = false;
    this.isSearched = true;
    // getRawValue so filters pinned via `disabled` still reach the search payload.
    this.searchEvent.emit(this.timesheetSearchForm.getRawValue());
  }

  exportToExcel() {
    this.showErrors = false;
    this.exportEvent.emit(this.timesheetSearchForm.getRawValue());
  }

  onSearchChequeClick() {
    this.showErrors = false;
    if (this.timesheetSearchForm.get('consumerPplId')?.value && this.timesheetSearchForm.get('consumerPplId')?.value.trim() &&
      this.timesheetSearchForm.get('providerPplId')?.value && this.timesheetSearchForm.get('providerPplId')?.value.trim()) {
      this.searchEvent.emit({ ...this.timesheetSearchForm.getRawValue(), "chequeLookUp": true });
    } else {
      this.showErrors = true;
    }
  }

  disabledFutureDates = (current: Date): boolean => {
    const serviceDateConfiguration = this.filterFields?.find(entry => entry.field === 'serviceDate');
    if (serviceDateConfiguration?.hideFuturePeriods) {
      const today = new Date();
      return current.getTime() > today.getTime();
    }

    return false;
  };
}
